
<template>

    <information-modal title="Delete"
        key="confirmDialog"
        ref="confirmDialog"
        :show-footer="true"
        className="confirm"
        @dismiss="hideCreateEditor">
        Are You Sure?
        <template v-slot:footer>
            <button type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal">No</button>

            <button type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal">Yes</button>
        </template>
    </information-modal>

    <information-modal title="Create Audit"
        :show-modal="isShowCreateEditor"
        ref="createDialog"
        @dismiss="hideCreateEditor">
        <form @submit.prevent="createAudit">
            <fieldset class="border-bottom mb-3">
                <div class="mb-3 row">
                    <label for="auditorName"
                        class="col-sm-3 col-form-label">Audit Name:</label>
                    <div class="col-sm-9">
                        <text-input name="auditorName"
                            type="text"
                            v-model="audit.auditName"
                            :error="errors.auditName" />
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="disabledSelect"
                        class="col-sm-3 col-form-label">Agency:</label>
                    <div class="col-sm-9">
                        <Multiselect v-model="audit.agency"
                            :options="agencies"
                            :multiple="false"
                            :close-on-select="true"
                            :class="{ 'is-invalid': !!errors.agency}"
                            :label="'label'"
                            :searchable="true"
                            :filter-results="true"
                            :strict="false"
                            :submit="false"
                            :native-support="true" />
                        <span class="invalid-feedback"
                            role="alert"
                            v-if="errors.agency">
                            {{ errors.agency}}
                        </span>

                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-sm-3 col-form-label">Start Date:</label>
                    <div class="col-sm-9">
                        <Datepicker :format="dateFormat"
                            v-model="audit.startDate"
                            :clearable="false"
                            :class="{ 'is-invalid': !!errors.startDate}"
                            :enable-time-picker="false"
                            :input-class-name="!!errors.startDate?'form-control is-invalid':'form-control'">
                        </Datepicker>
                        <span class="invalid-feedback"
                            role="alert"
                            v-if="errors.startDate">
                            {{ errors.startDate}}
                        </span>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-sm-3 col-form-label">Planned End Date:</label>
                    <div class="col-sm-9">
                        <Datepicker :format="dateFormat"
                            v-model="audit.plannedEndDate"
                            :clearable="false"
                            :enable-time-picker="false"
                            :input-class-name="!!errors.plannedEndDate?'form-control is-invalid':'form-control'">
                        </Datepicker>
                    </div>
                </div>

                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-sm-3 col-form-label">Audit to Cover:</label>
                    <div class="col-sm-9">
                        <div class="row">
                            <div class="col">
                                <label for="startMonth"
                                    class="col-form-label">Start Month:</label>
                                <Datepicker v-model="startMonth"
                                    :clearable="false"
                                    :enable-time-picker="false"
                                    :class="{ 'is-invalid': !!errors.startMonth}"
                                    @update:model-value="audit.startMonth=new Date(startMonth.year, startMonth.month, 1)"
                                    :month-picker="true"
                                    format="MM-yyyy"
                                    :input-class-name="!!errors.startMonth?'form-control is-invalid':'form-control'">
                                </Datepicker>
                                <span class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.startMonth">
                                    {{ errors.startMonth}}
                                </span>
                            </div>
                            <div class="col">
                                <label for="endMonth"
                                    class="col-form-label">End Month:</label>
                                <Datepicker v-model="endMonth"
                                    :clearable="false"
                                    @update:model-value="audit.endMonth=new Date(endMonth.year, endMonth.month, 0)"
                                    :month-picker="true"
                                    format="MM-yyyy"
                                    :class="{ 'is-invalid': !!errors.endMonth}"
                                    :enable-time-picker="false"
                                    :input-class-name="!!errors.endMonth?'form-control is-invalid':'form-control'">
                                </Datepicker>
                                <span class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.endMonth">
                                    {{ errors.endMonth}}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="mb-4 row">
                    <label for="agencyContactRole"
                        class="col-sm-3 col-form-label">Agency Contact:</label>
                    <div class="col-sm-9">
                        <select id="agencyContactRole"
                            v-model="audit.agencyContactRole"
                            class="form-select">
                            <option value="0">N/A</option>
                            <option v-for="item in agencyContactsStore.items"
                                :value="item.value"
                                :key="item.value">{{ item.label }}</option>

                        </select>
                        <span class="invalid-feedback"
                            role="alert"
                            v-if="errors.agencyContactRole">
                            {{ errors.agencyContactRole}}
                        </span>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="auditorName"
                        class="col-sm-3 col-form-label">Auditor Name:</label>
                    <div class="col-sm-9">

                        <text-input name="auditorName"
                            type="text"
                            v-model="audit.auditorName"
                            :error="errors.auditorName" />

                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-sm-3 col-form-label">Auditor Email Address:</label>
                    <div class="col-sm-9">
                        <text-input name="auditorName"
                            type="text"
                            v-model="audit.auditorEmailAddress"
                            :error="errors.auditorEmailAddress" />
                    </div>
                </div>

            </fieldset>
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal">Cancel</button>
                <button class="btn btn-primary"
                    type="submit">Save</button>
            </div>
        </form>
    </information-modal>
    <system-alerts></system-alerts>
    <div class="audits-grid">

        <b-filter-modal :isShowFilterEditor="isShowFilterEditor"
            :filterOptions="auditStore.filterOptions"
            :filterableFields="auditStore.filterableFields"
            @filterChanged="applyFilters"
            @dismissModal="handleDismiss"></b-filter-modal>

        <b-table-header :value="auditStore.tableOptions"
            @optionChange="handleOptionChange"
            header-slot-class="b-header-slot w-100 position-relative">

            <button @click.prevent="showCreateEditor"
                v-if="canAdd"
                class="btn btn-primary me-2">
                Create Audit
            </button>

            <button @click.prevent="showFilterEditor"
                class="btn btn-primary">
                <i class="bi bi-search pe-1"></i>
                Filter
            </button>
            <slot name="header.toolbar"></slot>
            <span class="ms-2 filter-description"
                v-if="hasAppliedFilters">
                {{ filtersDescription }}
            </span>
            <button v-if="hasAppliedFilters"
                class="btn-close"
                v-tooltip="'Remove all currently applied filters.'"
                @click.prevent="resetFilters()">
            </button>
        </b-table-header>
        <b-table :items="auditStore.items"
            :columns="columns"
            :caption="'List of audits'"
            :value="auditStore.tableOptions"
            @optionChange="handleOptionChange">

            <template #cell.auditName="{ item }">

                <a class="btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start"
                    v-if="item.status=='In Progress'|| item.status=='Closed' || item.status=='New'"
                    :href="`AgencyCommunicationAuditsDetails.aspx?id=${item.id}`"> {{item["auditName"] }}</a>
                <span v-else>
                    {{ item["auditName"] }}
                </span>

            </template>
            <template #header.documentsAccepted="{ item }">
                (% of requested)
            </template>
            <template #cell.documentsAccepted="{ item }">
                <span v-if="item.documentsAccepted">
                    {{ item.documentsAccepted }} ({{ item.documentsAcceptedPercentage}}%)
                </span>
            </template>
            <template #header.uploadedNarratives="{ item }">
                (% of incidents)
            </template>
            <template #cell.uploadedNarratives="{ item }">
                <span v-if="item.uploadedNarratives">
                    {{ item.uploadedNarratives }} ({{ item.uploadedNarrativesPercentage }}%)
                </span>
            </template>

            <template #header.completedReviews="{ item }">
                (% of incidents)
            </template>
            <template #cell.completedReviews="{ item }">
                <span v-if="item.completedReviews">
                    {{ item.completedReviews }} ({{ item.completedReviewsPercentage }}%)
                </span>
            </template>

            <template #header.passedReviews="{ item }">
                (% of completed reviews)
            </template>

            <template #cell.passedReviews="{ item }">
                <span v-if="item.passedReviews">
                    {{ item.passedReviews }} ({{ item.passedReviewsPercentage }}%)
                </span>
            </template>

            <template #cell.status="{ item }">

                <a class="btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start"
                    v-if="item.status=='Failed'"
                    @click="showFailedDialog"
                    :href="`AgencyCommunicationAuditsDetails.aspx?id=${item.id}`"> {{item["status"] }}</a>
                <span v-else>
                    {{ item["status"] }}
                </span>

            </template>

            <template #cell.reportFileId="{ item }">
                <a :href="`api/v1/audit/file/${item.reportFileId}`"
                    class="btn btn-sm btn-secondary"
                    v-if="item.reportFileId">View Report</a>
                <span v-else></span>
            </template>
        </b-table>
        <b-table-header :value="auditStore.tableOptions"
            @optionChange="handleOptionChange"
            header-slot-class="b-header-slot w-100">
        </b-table-header>
    </div>

</template>
<script lang="ts" setup>
import { ref, reactive, computed } from "vue";

import BTable from "./BTable/BTable.vue";
import BTableHeader from "./BTable/BTableHeader.vue";
import { BTableColumn, BTableOptions } from "./BTable/BTable.types";
import Datepicker from "@vuepic/vue-datepicker";
import Multiselect from "@vueform/multiselect";
import {
    describeFilters,
    BFilterOptions,
} from "./BFilterEditor/BFilterEditor.types";
import BFilterModal from "./BFilterEditor/BFilterModal.vue";
import { useOriStore } from "@/stores/oriStore";

import InformationModal from "./Misc/InformationModal.vue";
import SystemAlerts from "./Misc/SystemAlerts.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import { SelectItem, UploadType } from "@/types";
import { useAuditStore } from "@/stores/auditStore";
import type { Audit } from "../audit.types";
import { useFormValidation } from "../validation";
import TextInput from "./Fields/TextInput.vue";
import { object, string, date } from "yup";
import { useAgencyContactsStore } from "@/stores/agencyContactsStore";
import { debounce } from "vue-debounce";

const props = defineProps<{
    title: String;
    runAudits: boolean;
    createAudits: boolean;
}>();

var updateData = debounce(() => getData(), "15000ms");

const dateFormat = "yyyy-MM-dd";

const audit = ref<Audit>({} as Audit);

const isShowCreateEditor = ref(false);

const startMonth = ref();
const endMonth = ref();

const hasAppliedFilters = ref(false);
const auditStore = useAuditStore();
const agencyContactsStore = useAgencyContactsStore();

const schema = object<Audit>({
    auditName: string().required().label("Audit Name"),
    agency: string().required().label("Agency"),
    startDate: date().required().label("Start Date"),
    startMonth: date().required().label("Start Month"),
    agencyContactRole: string().required().label("Agency Contact"),
    endMonth: date()
        .required()
        .label("End Month")
        .when("startMonth", (startMonth, schema) => {
            console.log("date", audit.value.startMonth);
            if (audit.value.startMonth) {
                const dayAfter = new Date(
                    audit.value.startMonth.getTime() + 86400000
                );

                console.log(
                    "date",
                    audit.value.startMonth,
                    audit.value.endMonth,
                    dayAfter
                );
                return schema.min(
                    dayAfter,
                    "End month has to be after than start month"
                );
            }

            return schema;
        }),
    auditorName: string().required().label("Auditor Name"),
    auditEmailAddress: string().email().label("Audit Email Address"),
});

const oriStore = useOriStore();
oriStore.dataset = UploadType.nibrs;

const agencies = computed(() => {
    const values = oriStore.oris;
    let list = values.map(
        (m) =>
            ({
                label: `${m.ori} - ${m.agency}`,
                value: m.ori,
            } as SelectItem)
    );

    return list;
});

const columns = reactive<BTableColumn[]>([
    {
        key: "auditName",
        text: "Audit Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["auditName"],
    },
    {
        key: "agencyName",
        text: "Agency Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["agencyName"],
    },
    {
        key: "startDate",
        text: "Start Date",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item.startDate,
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item["status"],
    },

    {
        key: "incidents",
        text: "Documents requested",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["documents"],
    },
    {
        key: "documentsAccepted",
        text: "Documents accepted",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["documentsAccepted"],
    },

    {
        key: "incidents",
        text: "Incidents",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["incidents"],
    },
    {
        key: "uploadedNarratives",
        text: "Uploaded Narratives",
        class: (item) => ["text-center"],
        columnClass: ["text-center"],
        sortable: false,
        value: (item) => item["uploadedNarratives"],
    },
    {
        key: "completedReviews",
        text: "Completed Reviews",
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
        sortable: false,
        value: (item) => item["completedReviews"],
    },
    {
        key: "passedReviews",
        text: "Passed Reviews",
        class: (item) => ["text-center"],
        columnClass: ["text-center"],
        sortable: true,
        value: (item) => item["passedReviews"],
    },
    {
        key: "reportFileId",
        text: "Report File",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-wrap"],
        value: (item) => item["reportFileId"],
    },
]);

const showCreateEditor = async function () {
    audit.value = {} as Audit;
    isShowCreateEditor.value = true;
    let user = await auditStore.getCurrentUser();
    audit.value.auditorEmailAddress = user.email;
    audit.value.agencyContactRole = "0";
    audit.value.auditorName = `${user.firstName} ${user.lastName}`.trim();
};
const hideCreateEditor = function () {
    isShowCreateEditor.value = false;
};

const isShowFilterEditor = ref(false);
const showFilterEditor = function () {
    isShowFilterEditor.value = true;
};

const handleOptionChange = async function (options: BTableOptions) {
    auditStore.tableOptions = options;
    await getData();
};
const handleDismiss = function () {
    isShowFilterEditor.value = false;
};
const resetFilters = async function () {
    if (auditStore.filterOptions != null) {
        auditStore.filterOptions.filters = [];
        await getData();
    }
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = false;
};
const applyFilters = async function (newFilterOptions: BFilterOptions) {
    auditStore.filterOptions = newFilterOptions;
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = auditStore.filterOptions.filters.length > 0;
    await getData();
};

const filtersDescription = computed(() => {
    if (auditStore.filterOptions == null) {
        return "";
    }
    return describeFilters(
        auditStore.filterOptions.filters,
        auditStore.filterableFields
    );
});

const getData = async function () {
    await auditStore.list();
    await updateData();
};

const canAdd = computed(() => props.createAudits);

const canDelete = function (): boolean {
    return props.runAudits;
};

const { handleSubmit, errors } = useFormValidation();

const createAudit = async () => {
    if (await handleSubmit(schema, audit.value)) {
        await auditStore.create(audit.value);
        await getData();
        await hideCreateEditor();
        audit.value = {} as Audit;
    }
};

await getData();
await agencyContactsStore.list();
</script>